import { extend } from 'flarum/common/extend';
import app from 'flarum/forum/app';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
import PostControls from 'flarum/forum/utils/PostControls';
import Button from 'flarum/common/components/Button';
app.initializers.add('fof-author-change', () => {
  extend(DiscussionControls, 'moderationControls', function (items, discussion) {
    if (!app.forum.attribute('fofAuthorChangeCanEditUser') && !app.forum.attribute('fofAuthorChangeCanEditDate')) {
      return;
    }
    items.add('fof-author-change', Button.component({
      icon: 'fas fa-user-edit',
      onclick() {
        app.modal.show(() => import(/* webpackChunkName: 'forum/components/UpdateAuthorModal', webpackMode: 'lazy-once' */ './components/UpdateAuthorModal'), {
          related: discussion
        });
      }
    }, app.translator.trans('fof-author-change.forum.controls.edit')));
  });
  extend(PostControls, 'moderationControls', function (items, post) {
    if (!app.forum.attribute('fofAuthorChangeCanEditUser') && !app.forum.attribute('fofAuthorChangeCanEditDate')) {
      return;
    }
    items.add('fof-author-change', Button.component({
      icon: 'fas fa-user-edit',
      onclick() {
        app.modal.show(() => import(/* webpackChunkName: 'forum/components/UpdateAuthorModal', webpackMode: 'lazy-once' */ './components/UpdateAuthorModal'), {
          related: post
        });
      }
    }, app.translator.trans('fof-author-change.forum.controls.edit')));
  });
});flarum.reg.addChunkModule('753', '800', 'fof-author-change', 'forum/components/UpdateAuthorModal');
flarum.reg.addChunkModule('753', '800', 'fof-author-change', 'forum/components/UserSearch');
flarum.reg.addChunkModule('753', '800', 'fof-author-change', 'forum/components/UsersSearchSourceWithoutInternalRouting');